import React from 'react';

import gaUserClickedLink from './ga/gaUserClickedLink';

export default () => (
  <div className="main-footer">
    <div id="footer">
      <p><a
        href="https://dannyroosevelt.com/ratethatmeeting-assets/should-it-be-a-meeting-flowchart.pdf"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => gaUserClickedLink('User clicked Download Flowchart')}>
        Download the flowchart
      </a>
      </p>
      <p id="rtm-link">
        Made with{' '}
        <span role="img" aria-label="heart" className="emoji">
          ❤️
        </span>
        {' '}by{' '}
        <a
          href="https://dylburger.com/?utm_source=shoulditbeameeting.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            gaUserClickedLink(
              'User clicked Dylan link from Footer',
            )}
        >
          Dylan
        </a>
        {' '}and{' '}
        <a
          href="https://dannyroosevelt.com/?utm_source=shoulditbeameeting.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            gaUserClickedLink(
              'User clicked Danny link from Footer',
            )}
        >
          Danny
        </a>
      </p>
      <p>
        <a
          href="https://ratethatmeeting.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => gaUserClickedLink('User clicked Privacy link')}>
          Privacy
        </a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a
          href="https://ratethatmeeting.com/terms/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => gaUserClickedLink('User clicked Terms link')}>
          Terms
        </a>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/Footer.js